import React, { useEffect, useState, useContext, useRef } from "react";

import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from '../context/BasicContext'

import { Search } from "./SVG";

type MyCourseState = {
    ActID: string,
    ActTitle: string,
    recLYear: number | null,
    recRYear: number | null,
    RealCompleteDate: string,
    Class1: string,
    Class1Name: string,
    Class2: string,
    Class2Name: string,
    RecordTime: number,
    isComplete: number,
    //ExamDataJson: string | null
    Exam: string | null
    Hours: number
}

type ExamObject = {
    ExamID: string,
    Score: string,
    ExamName: string
}
let orgData: MyCourseState[] = []
export default () => {
    //const count = useSelector((state: StoreType) => { state })
    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)



    const [stateData, setStateData] = useState<MyCourseState[]>([])
    const [renderData, setRenderData] = useState<MyCourseState[]>([])
    const [menuData, setMenuData] = useState<number[]>([])
    const [page, setPage] = useState<number>(0)

    const keywordInput = useRef<HTMLInputElement>(null)


    useEffect(() => {
        //法定必修
        ws.WebService.asyncGetActCompleteList().then((res: any) => {
            /*
            */
           //const temp: (MyCourseState)[] = []
           orgData = res as MyCourseState[]
            setStateData(res as MyCourseState[])

        })

        //選修課程
        return
    }, [])

    useEffect(() => {
        if (stateData.length > 0) {
            let temp: MyCourseState[] = []
            for (let i: number = 0; i < 10; i++) {
                if (stateData[i + (page * 10)]) {
                    temp.push(stateData[i + (page * 10)])
                }
            }
            
            setRenderData(temp)

            let menu: number[] = []
            for (let i: number = 0; i < Math.ceil(stateData.length / 10); i++) {
                menu.push(i + 1)
            }
            setMenuData(menu)
        }

    }, [page, stateData])


    const searchByKeyWord = (keyword: string) => {
        if (keyword != "") {
           

            const sortData: MyCourseState[] = []
            //alert(keyword)
            orgData.map((item: MyCourseState) => {
                let flat: string = ""
                for (let key in item) {
                    flat += item[key as keyof MyCourseState] + ","
                }

                if (flat.match(keyword) != null) {
                    sortData.push(item)
                }
            })
            setStateData(sortData)
            console.log(sortData)
        } else {
            setStateData(orgData)

        }
        setPage(0)
    }

    return (
        <>
            <div id="courseState">
                <div className="searchBox">
                    <input className="hibInput" ref={keywordInput} placeholder="搜尋課程" onChange={() => {
                        if (keywordInput && keywordInput.current) {
                            searchByKeyWord(keywordInput.current.value)
                        }
                    }} />
                    {/**
                     * 
                    <button className="hibBtn main" onClick={()=>{
                        if(keywordInput && keywordInput.current){
                            searchByKeyWord(keywordInput.current.value)
                        }
                    }}><Search/></button>
                        */}
                </div>
                <div className="HibTable">
                    <div className="HibTableHeader">
                        <div className="ActNO">No.</div>
                        <div className="ActClass1">課程類別</div>
                        <div className="ActDate">完課日期</div>
                        <div className="ActHours">完課時數</div>
                        {/**
                         * 
                        <div className="ActIsComplete">完課狀況</div>
                        <div className="ActRecodeTime">觀看時數</div>
                         */}
                        <div className="ActTitle">單元名稱</div>
                        <div className="Exam">試卷分數</div>
                        {
                            /*
                            <div className="recLYear">壽險認列年度</div>
                            <div className="recRYear">產險認列年度</div>
                             */
                        }
                    </div>
                    <div className="tableRows">

                        {
                            renderData.map((state: MyCourseState, index: number) => {
                                //console.log(state)
                                return (
                                    <div key={"row" + index} className={"HibTableTemplate HibTableRow Class1_" + state.Class1}>
                                        <div className="ActNO">
                                            <span className="title">No.</span>
                                            <span className="val">{(index + 1) + (page * 10)}</span>
                                        </div>
                                        <div className="ActClass1">
                                            <span className="title">課程類別</span>
                                            <span className="val">{
                                                state.Class1Name == "A" ? "活動報名" :
                                                    state.Class1Name == "B" ? "課程報名" :
                                                        state.Class1Name == "C" && "數位學習"
                                            }</span>
                                        </div>
                                        {/**
                                         * 
                                        <div className="ActID">
                                            <span className="title">單元ID：</span>
                                            <span className="val">{state.ActID}</span>
                                        </div>
                                        */}
                                        {/* */}
                                        <div className="ActDate">
                                            <span className="title">完課日期：</span>
                                            <span className="val">{
                                                state.RealCompleteDate ?
                                                    state.RealCompleteDate :
                                                    "無"
                                            }</span>
                                        </div>
                                        <div className="ActHours">
                                            <span className="title">完課時數：</span>
                                            <span className="val">
                                                {
                                                    state.Hours < 1 ?
                                                    (state.Hours * 60) + "分鐘":
                                                    state.Hours + "小時"
                                                }
                                            </span>
                                        </div>
                                        {/** 
                                        <div className="ActIsComplete">
                                            <span className="title">完課狀況</span>
                                            <span className="val">{
                                                state.isComplete == 1 ?
                                                    <span className="done">已完成</span> :
                                                    state.isComplete == 0 ?
                                                        <span className="notDone">未完成</span> :
                                                        state.isComplete}</span>
                                            
                                        </div>

                                        <div className="ActRecodeTime">
                                            <span className="title">觀看時數</span>
                                            <span className="val">
                                                {
                                                    state.Class1 == "C" ?
                                                        Math.floor(state.RecordTime / 60) + "分" :
                                                        "無"
                                                }
                                            </span>
                                        </div>
*/}

                                        <div className="ActTitle">
                                            <span className="title">單元名稱：</span>
                                            <span className="val">
                                                <span className="subActTitle">
                                                    {state.ActID}
                                                    {
                                                        state.Class2 ?
                                                            "-" + state.Class2Name : ""
                                                    }
                                                </span>
                                                {state.ActTitle}
                                            </span>
                                        </div>
                                        {
                                            /**
                                             * 
                                            <div className="recLYear">
                                                <span className="title">壽險認列年度：</span>
                                                <span className="val">109</span>
                                            </div>
                                            <div className="recRYear">
                                                <span className="title">產險認列年度：</span>
                                                <span className="val">無</span>
                                            </div>
                                            */
                                        }
                                        <div className="Exam">
                                            {
                                                state.Exam && <>
                                                    <span className="title">試卷分數：</span>
                                                    <div>
                                                        {

                                                            state.Exam &&
                                                            JSON.parse(state.Exam).map((item: ExamObject) =>
                                                                <div className="rowExam">
                                                                    {item.ExamName}：<span className="score">{item.Score}</span>分
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </>
                                            }
                                        </div>


                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
            </div>
            <div className="pager">
                <div className="prev">
                    <button className="hibBtn"
                        onClick={() => {
                            if (page - 1 >= 0) setPage(page - 1)
                        }}
                    >上一頁</button>
                </div>
                <div className="numPage">
                    {
                        menuData.map((item, index) => {
                            return (
                                <button key={"numPage_" + index} className={"hibBtn " + (page == index ? "active" : "")} onClick={() => { setPage(index) }}>
                                    <span>
                                        {item}
                                    </span>
                                </button>
                            )
                        })
                    }
                </div>
                <div className="next">
                    <button className="hibBtn"
                        onClick={() => {
                            if (page + 1 < Math.ceil(stateData.length / 10)) setPage(page + 1)
                        }}
                    >下一頁</button>
                </div>
            </div>
        </>
    )
}

